import { Alert } from '@synoptic/ui-kit/alert/alert.js';
import { CodeBracketsIcon } from '@synoptic/ui-kit/icons/react/code-brackets.js';
import { borderRadius } from '@synoptic/ui-kit/tokens.js';
import { useState } from 'react';
import { NavLink } from '@/routes-utils/navigation';
import { paths } from '@/routes-utils/paths';
import { localStorageService } from '@/services/local-storage-service';
import { useAuthInfo } from '../_app/use-auth-info';
import { adBody, adTitle, floatingAdPanel } from './route.css';

export const GraphAdPanel = () => {
  const [twttrApiAdClosed, setTwttrApiAdClosed] = useState(
    () => localStorageService.getItem('twttrApiAdClosed') === 'true',
  );

  const { id: userId } = useAuthInfo();

  const onClose = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();
    if (userId) {
      localStorageService.setItem('twttrApiAdClosed', 'true');
    }
    setTwttrApiAdClosed(true);
  };

  return twttrApiAdClosed ? null : (
    <NavLink
      to={paths.toolsTwttrApi}
      prefetch="intent"
      className={floatingAdPanel}
    >
      <Alert
        style={{
          backgroundColor: 'transparent',
          borderRadius: borderRadius.r8,
        }}
        size="small"
        icon={<CodeBracketsIcon />}
        onClose={onClose}
      >
        <div className={adBody}>
          <span className={adTitle}>Check our Twitter API by OpticFeeds!</span>
          REST API for tweets, timelines, search, followers and detailed user
          metadata, served as JSON for rapid integration. Most competitive
          pricing on the market.
        </div>
      </Alert>
    </NavLink>
  );
};
